import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface RemoveEngagementDocumentRequest {
    timelineId: number;
    documentId: string;
}

export const RemoveEngagementDocument = createAsyncThunk(
    'timeline/removeEngagementDocument',
    async (
        { timelineId, documentId }: RemoveEngagementDocumentRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.put(
                `api/Marketplace/Engagements/${timelineId}/documents/${documentId}/remove`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not remove document at the moment.',
                    'error'
                );
                throw new Error('Failed to remove document');
            }

            return documentId;
        } catch (error) {
            createNotification(
                'An error occurred while removing the document.',
                'error'
            );
            throw error;
        }
    }
);
